import { render, staticRenderFns } from "./SmsEmailInfoPop.vue?vue&type=template&id=04bee7ce"
import script from "./SmsEmailInfoPop.vue?vue&type=script&lang=js"
export * from "./SmsEmailInfoPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04bee7ce')) {
      api.createRecord('04bee7ce', component.options)
    } else {
      api.reload('04bee7ce', component.options)
    }
    module.hot.accept("./SmsEmailInfoPop.vue?vue&type=template&id=04bee7ce", function () {
      api.rerender('04bee7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/auth/SmsEmailInfoPop.vue"
export default component.exports